// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"d4_J6","blockHeader":"_2nvXg","conclusionContainer":"EMME6","content":"_1dBIx","toggler":"_2lsut","loading":"hUzZ2"};